import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of, switchMap, take, tap } from 'rxjs';
import { AppProfileService } from '../services/profile.service';
import { ApplicationPaths } from './api-authorization.constants';
import { AuthorizeService } from './authorize.service';

@Injectable({
  providedIn: 'root',
})
export class AppProfileGuard {
  private profileService = inject(AppProfileService);
  private authService = inject(AuthorizeService);
  private router = inject(Router);

  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.profileService.currentProfile$.pipe(
      take(1),
      tap((p) => {
        if (p) {
          if (state.url == '/shop-welcome-appdata') {
            this.router.navigate(['']);
          }
        } else {
          this.authService
            .getUser()
            .pipe(take(1))
            .subscribe(() => {
              this.router.navigate([ApplicationPaths.ApplicationProfileWelcomePage]);
            });
        }
      }),
      switchMap((p) => {
        return of(p != null);
      })
    );
  }
}
